export default __webpack_public_path__ + "static/media/HomemKMobile.c3b2217c.png";